import { Field } from 'react-final-form';
import sortBy from 'lodash/sortBy';

import type { SkillTProficiencyDto, SkillTaxonomyTreeDto } from '@eva/types/dto';

import { getProficiencyOptions } from '../../functions';

import { FieldSkillTreeWithOptionalProficiency } from './SkillTreeWithOptionalProficiency';

type SkillTaxonomyTreeItemFormType = {
  isEditSkill: boolean;
  isDisabled: boolean;
  skillTaxonomyTree: SkillTaxonomyTreeDto;
  onExpandGroup: (group: any) => void;
  skillProficiencies: SkillTProficiencyDto[];
  isUpdatingEntity: boolean;
  highlightSkillLabelMemoized?: (skill: any) => void;
};

/**
 * showOnlyNonEmpty equal true is not show groups without skills in editMode
 *
 * showOnlySelected equal true is's for notEditMode to show only selectedOptions
 *
 * disabled equal true not show checkbox on skills
 */

export const SkillTaxonomyTreeItemForm: React.FC<SkillTaxonomyTreeItemFormType> = ({
  skillTaxonomyTree,
  isEditSkill,
  highlightSkillLabelMemoized,
  onExpandGroup,
  skillProficiencies,
  isDisabled,
  isUpdatingEntity,
}) => (
  <Field
    showOnlyNonEmpty
    name="skills"
    menu={skillTaxonomyTree}
    showOnlySelected={!isEditSkill}
    disabled={isDisabled}
    proficiencyOptions={sortBy(getProficiencyOptions(skillProficiencies || []), 'value')}
    component={FieldSkillTreeWithOptionalProficiency}
    onExpandGroup={onExpandGroup}
    getOptionLabel={highlightSkillLabelMemoized}
    isUpdatingEntity={isUpdatingEntity}
  />
);
